// @flow
import React, { type Node } from 'react';
import { Track } from 'angieslist-app-platform';
import { Button } from 'angieslist-react-components';
import { compose, pure } from 'recompose';
import './metricsCard.scss';

type Props = {
  metrics: any,
}

type State = {
  showLearnMoreModal: boolean,
}

export class MetricsCard extends React.Component<Props, State> {
  state: State = { showLearnMoreModal: false };
  props: Props;

  openLearnMoreModal: (() => void) = () => {
    this.setState({ showLearnMoreModal: true });
  };

  closeLearnMoreModal: (() => void) = () => {
    this.setState({ showLearnMoreModal: false });
  };
  openLink: ((string) => void) = (link) => {
    window.location.href = link;
  };

  render(): Node {
    const {
      metrics,
    } = this.props;


    return (
      <div id="metrics-card-container">
        <div id="metrics-card-title-container">
          <div className="metrics-title National2-Bold">
            Recent Activity
          </div>
          <Track>
            <div
              id="learn-more-link"
              className="National2-Medium"
              onClick={this.openLearnMoreModal}
              onKeyDown={this.openLearnMoreModal}
              role="button"
              tabIndex={0}
            >
              Learn more
            </div>
          </Track>
        </div>
        <div id="metrics-card-items">
          {
            metrics.map((metric) => {
              const linkProps = metric.link ? {
                onClick: () => this.openLink(metric.link),
                onKeyDown: () => this.openLink(metric.link),
                role: 'button',
                tabIndex: 0,
              } : null;

              return (
                <Track>
                  <div
                    id={`metrics-card-item--${metric.id}`}
                    className={metric.link ? 'metrics-card-item center-container metric-link' : 'metrics-card-item center-container'}
                    {...linkProps}
                  >
                    <div className="center-y">
                      <div className="metrics-card-item-value National2-Bold">
                        {metric.value ? metric.value : 0}
                      </div>
                      <div className="metrics-card-item-title National2-Medium">
                        {metric.title}
                      </div>
                    </div>
                  </div>
                </Track>
              );
            })
          }
        </div>
        <If condition={this.state.showLearnMoreModal}>
          <div id="metrics-card--learn-more-modal">
            <div id="metrics-card--learn-more-modal-title" className="National2-Bold">
              Activity insights
            </div>
            <div id="metrics-card--learn-more-modal-content" >
              <div className="metrics-card--learn-more-modal-content-item National2-Regular">
                Data reflects the past 30 days.
              </div>
              <div className="metrics-card--learn-more-modal-content-item National2-Regular">
                <b>Directory views:</b> when your business listing appears in a customer search.
              </div>
              <div className="metrics-card--learn-more-modal-content-item National2-Regular">
                <b>Profile visits:</b> when a customer views your profile page.
              </div>
              <div className="metrics-card--learn-more-modal-content-item National2-Regular">
                <b>Leads:</b> when a customer requests a quote from your business.
              </div>
              <div className="metrics-card--learn-more-modal-content-item National2-Regular">
                *Metrics can take up to 24 hours to refresh.
              </div>
            </div>
            <Button
              id="metrics-card--learn-more-modal-close-button"
              bsStyle="primary-office"
              className="National2-Bold"
              onClick={this.closeLearnMoreModal}
              flat
              block
            >
              Got it
            </Button>
          </div>
          <div
            id="metrics-card--learn-more-modal-backdrop"
            onClick={this.closeLearnMoreModal}
            onKeyDown={this.closeLearnMoreModal}
            role="button"
            tabIndex={0}
          />
        </If>
      </div>
    );
  }
}

export default (compose(pure)(MetricsCard): any);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/metricsCard.js